export default __webpack_public_path__ + "static/media/background_sky.3d1e7771.jpg";